var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{ref:"chart1",staticClass:"echarts chart chartBox",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }